const {Card} = require("../components/card/card");

$(document).ready(function() {
	// показать еще товары
	let paginator = {
		func : {
			updateAjaxContent(response){
				if (!!response) {
					if (!!response.content) {
						$('[data-product-container]').append(response.content);
						this.updateLazy();
						this.updateCards();
						this.updateFavorites();
						this.updateCardCountButtons();
						this.updateCardSize();
					}

					$('[data-paginator-container]').html(response.paginator);
				}

				if (typeof window.Counters !== 'undefined') {
					window.Counters.GA_PaginatorLoadMore(response);
				}

				$('body').removeClass('body--loading');
			},

			updateLazy: function() {
				let img = $('[data-product-container]').find('.lazyload');
				let lazy = new LazyLoad(img);
				lazy.loadImages();
			},

            updateCards: function() {
                $('[data-product-container]').find('.row').last().find('[data-card]').each(function(i) {
                    let card = new Card($(this));
                    card.initialize();
                });
            },

            updateFavorites: function() {
                if (typeof window.Favorites !== 'undefined') {
                    window.Favorites.initLinks();
                }
            },

            updateCardCountButtons: function() {
                if (typeof window.checkCardCountButtons !== 'undefined') {
                    window.checkCardCountButtons();
                }
            },

            updateCardSize: function() {
								if ($(window).width() > 767 ) {
									$('.tool-grid-desktop').find('[data-catalog-tool].active').click();
								} else {
									$('.tool-grid-mobile').find('[data-catalog-tool].active').click();
								}
            },
		}
	}

	$(document).on('click', '[data-show-more]', function() {
		let url = $(this).attr('data-page-url');
		let pageNum = $(this).attr('data-page-num');
		if (!!pageNum) {
			$('body').addClass('body--loading');
			$.ajax({
				url      : url,
				method   : 'GET',
				dataType : 'JSON',
				data     : {
					PAGEN_1 : pageNum,
					action  : 'showMore'
				}
			}).done(function(response) {
					paginator.func.updateAjaxContent(response);
			});
		}
	});
});
